// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"788":"48f5d943","840":"5e9c85f2"}[chunkId] + ".chunk.css";
};